import { useLazyLoadQuery } from 'react-relay';

import { noticeQuery } from '@/__generated__/noticeQuery.graphql';
import { notice } from '@/graphql/query/tax-refund/notice';

export const useNotice = () => {
  const result = useLazyLoadQuery<noticeQuery>(notice, {});

  return result.notice;
};
